import { useEffect, useState } from "react";
import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL_EC2;

export default function SummaryCount() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await axios.get(`${API_URL}/api/getemailcount`);
        setData(response.data.data);
      } catch (err) {
        setError("Failed to fetch data");
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;

  return (
    <center>
      <div className="p-4">
        <h2 className="text-xl font-bold mb-4">Email Count Table</h2>
        <div className="p-1">
          <table className="min-w-full bg-white border-4 border-black border-solid">
            <thead>
              <tr className="bg-gray-100">
                <th className="border px-4 py-2">Email</th>
                <th className="border px-4 py-2">Count</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr key={item._id} className="text-center">
                  <td className="border px-4 py-2">{item.email}</td>
                  <td className="border px-4 py-2">{item.count}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </center>
  );
}
